import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import routeFactory from '../../../common/util/routeFactory';
import { selectAccount } from '../shared/ducks';
import { AccountRemappingModal } from './components/AccountRemappingModal';

type RouteParams = {
  accountSubdomain: string;
};

export const AccountRemapRoute: React.FC = () => {
  const navigate = useNavigate();
  const { accountSubdomain: currentAccountSubdomain } = useParams<RouteParams>();
  const account = useSelector(selectAccount);

  const onCancel = useCallback(() => {
    if (!account) {
      return null;
    }

    navigate(routeFactory.accountRolodex.getUrlPath({ accountSubdomain: account.subdomain }));
  }, [account, navigate]);

  if (!account) {
    return null;
  }

  return (
    <AccountRemappingModal
      onClose={onCancel}
      currentAccountSubdomain={currentAccountSubdomain ?? ''}
    />
  );
};
